let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("56HnP")).then(() => parcelRequire('bzEe0'));